const stripUndefinedProps = objArg => {
  const obj = { ...objArg };

  Object.keys(obj).forEach(key => obj[key] === undefined && delete obj[key]);

  return obj;
};

export default stripUndefinedProps;
